import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

const featuredSlugs = [
  'learn-to-love-yourself-first',
  'the-courage-to-love-deeply',
  'five-love-languages-chinese-way',
];

export default function FeaturedArticles() {
  const featured = articles.filter((a) => featuredSlugs.includes(a.slug));

  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between mb-12 gap-4">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">精选文章</h2>
            <p className="text-sm text-foreground-600">从我们的编辑团队精选的深度好文，带你感受爱的力量。</p>
          </div>
          <Link
            to="/category/love-yourself"
            className="text-sm text-primary-500 hover:text-primary-600 font-medium flex items-center gap-1 whitespace-nowrap transition-colors duration-200"
          >
            浏览全部
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line"></i>
            </span>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {featured.map((article, index) => (
            <article key={article.slug} className="group">
              <Link to={`/article/${article.slug}`} className="block">
                <div className="relative overflow-hidden rounded-lg mb-4 aspect-[16/10]">
                  <img
                    src={article.imageUrl}
                    alt={article.title}
                    title={article.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute top-3 left-3">
                    <span className="bg-primary-500 text-background-50 text-xs px-3 py-1 rounded-full whitespace-nowrap">
                      {index === 0 ? '编辑推荐' : index === 1 ? '热门文章' : '深度好文'}
                    </span>
                  </div>
                </div>
                <div className="flex items-center gap-3 text-xs text-foreground-500 mb-2 flex-wrap">
                  <span className="bg-accent-100 text-accent-800 px-2.5 py-0.5 rounded-full whitespace-nowrap">
                    {article.categoryName}
                  </span>
                  <span>{article.date}</span>
                  <span>{article.readTime}</span>
                </div>
                <h3 className="font-heading text-lg text-foreground-950 mb-2 group-hover:text-primary-500 transition-colors duration-200 line-clamp-2">
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed line-clamp-3">
                  {article.excerpt}
                </p>
              </Link>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}